import { isWeb } from '@mythical/ui'
import { UserStore } from 'app/store/user-store'

import type { PlaylistItem } from '@jwplayer/jwplayer-react-native'

export interface VideoProps {
  id: string
  url: string
  title?: string
  thumbnail?: string
  player: string
  captions?: string
  data?: { playlist?: any[] }
  contentId?: string
  userStore?: UserStore
  currentProgress?: number
  muted?: boolean
  autoplay?: boolean
  onVideoPlay?: () => void
  onVideoPause?: () => void
  onVideoEnd?: () => void
  onVideoProgress?: (progress: number) => void
}

interface ExPlaylistItem extends PlaylistItem {
  starttime: number
}

export const propsToPlaylistItem = (props: VideoProps): ExPlaylistItem => {
  console.log('props.data?.playlist', JSON.stringify(props.data?.playlist, null, 2))

  if (props.data?.playlist && isWeb) {
    const item = props.data.playlist[0] as ExPlaylistItem

    delete item.title
    delete item.description

    item.startTime = props.currentProgress || 0
    item.starttime = props.currentProgress || 0

    return item
  }

  const dataTracks = Array.isArray(props.data?.playlist?.[0]?.tracks)
    ? props.data.playlist[0].tracks
        .filter(
          (track: any) =>
            !!track?.file &&
            (!track?.kind ||
              track.kind === 'captions' ||
              track.kind === 'subtitles'),
        )
        .map((track: any) => ({
          file: track.file,
          label: track.label || 'English',
          kind: 'captions',
        }))
    : []

  let tracks: any[] = dataTracks

  if (props.captions) {
    tracks = [
      {
        file: props.captions,
        label: 'English',
        kind: 'captions',
      },
      ...tracks.filter((track: any) => track.file !== props.captions),
    ]
  }

  return {
    file: props.url,
    image: props.thumbnail,
    tracks: tracks || [],
    startTime: props.currentProgress || 0,
    starttime: props.currentProgress || 0,
  }
}
